<mat-list>
  <mat-list-item *ngFor="let e of errorsDetails">
    {{ e.errorCode }}: {{ e.message }}
  </mat-list-item>
</mat-list>
